<template>
  <app-dropdown
    placeholder="Filter by Offices"
    track-by="id"
    label="displayName"
    :options="agencySelection"
    :loading="loading"
    :disabled="dropdownDisabled"
    v-bind="attrs"
    @on-selected="onAgencySelected"
    @on-removed="onAgencyRemoved"
  />
</template>

<script>
import AppDropdown from "../AppComponents/AppDropdown.vue";
import ApiMixin from "../../mixins/ApiMixin";
import LookupServices from "../../services/lookups";

/**
 * The value that indicates that selecting this from the
 * dropdown means the user is trying to select all
 * agencies.
 */
export const AgencyListAllOption = {
  id: 0,
  displayName: "All Offices",
  clientId: null
};

export default {
  mixins: [ApiMixin],
  // An array of clientIDs, if present it'll only fetch agencies under those clients.
  props: ["clientIds"],
  components: {
    AppDropdown
  },
  computed: {
    // The rest of the attributes
    attrs() {
      const { placeholder, options, ...rest } = this.$attrs;
      return rest;
    },
    // Function to determine if the dropdown should be disabled
    dropdownDisabled() {
      if (this.loading) return true;
      if (this.attrs.disabled) return this.attrs.disabled;

      return false;
    },
    // Holds the data for the agency selection to be displayed
    agencySelection() {
      let baseSelection = [];
      if (this.response) baseSelection = this.response.data.lookups;

      // Sort the agency list alphabetically.
      baseSelection.sort((a, b) => {
        const displayNameA = a.displayName || "";
        const displayNameB = b.displayName || "";
        return displayNameA.localeCompare(displayNameB);
      });

      // If client IDs are specified only show agencies under that client
      if (Array.isArray(this.clientIds) && this.clientIds.length > 0) {
        baseSelection = baseSelection.filter(agency => this.clientIds.includes(agency.clientId));
      }

      return [AgencyListAllOption, ...baseSelection];
    }
  },
  methods: {
    async fetchAgencies() {
      await this.request(LookupServices.getAgencies);
    },
    onAgencySelected(props) {
      this.$emit("on-agency-selected", props);
    },
    onAgencyRemoved(props) {
      this.$emit("on-agency-removed", props);
    }
  },
  mounted() {
    this.fetchAgencies();
  },
  inheritAttrs: false
};
</script>
